import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

function prepareDataRequest(data) {
  return { RequestCorrelationId: uuidv4(), Data: data };
}
export function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({ baseURL: api, withCredentials: false });
client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateCourtExpense(item) {
  return client.post("Expenses/CreateExpense", prepareDataRequest(item));
}
function UpdateCourtExpense(item) {
  return client.post("Expenses/UpdateExpense", prepareDataRequest(item));
}
function DeleteCourtExpense(id, uid) {
  return client.post("Expenses/DeleteExpense", prepareDataRequest({ id, commandUserId: uid }));
}
function GetCourtExpensesByCase(courtCaseId) {
  return client.post("Expenses/GetCourtExpensesByCase", prepareRequest({ courtCaseId }));
}

export {
  CreateCourtExpense,
  UpdateCourtExpense,
  GetCourtExpensesByCase,
  DeleteCourtExpense,
}
